<template>
	<div id="Exhibitionmetting" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/zhhy.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/zhhy_font.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>展会</span><span style="color:#D7230C;">会议</span></div>
					<div class="sm_pub">带你领略展会风采</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/zhhy">
				查看更多&nbsp;>
			</router-link>
		</div>
		<div class="Exhbigk" style="box-shadow: 0 4px 24px rgba(0,0,0,.16);">
			<div class="Exhbitop">
				<div class="Exhtopleft" style="background-color: #f54e39;">
					<div class="Exhtopleftimg">
						<img src="../imges/hyzh.png" style="height: 100%;width: 100%;" alt="">
					</div>
					<div class="Exhtitle">
						行业会议
					</div>
					<div class="Exhbutton" @click="nyxq">
						我要发布
					</div>
				</div>
				<div class="Exhtopright">
					<router-link :to="{ path:'/zhhydetail',query:{id:item.id,title:item.title,mid:'1'} }" class="Exhbomlist" v-for="(item,index) in xptjlist" :key="index" tag="div">
						<div class="Exhbomlistimg">
							<img v-lazy="item.picture" alt="">
						</div>
						<div class="Exhbomtitle">
							{{item.title}}
						</div>
					</router-link>
				</div>
			</div>
			<div class="Exhbiboom">
				<div class="Exhtopleft" style="background-color: #f06a35;">
					<div class="Exhtopleftimg">
						<img src="../imges/hyzh.png" style="height: 100%;width: 100%;" alt="">
					</div>
					<div class="Exhtitle">
						行业展会
					</div>
					<div class="Exhbutton" @click="nyxq">
						我要发布
					</div>
				</div>
				<div class="Exhtopright">
					<router-link :to="{ path:'/zhhydetail',query:{id:item.id,title:item.title,mid:'2'} }" class="Exhbomlist" v-for="(item,index) in xptjlists" :key="index" tag="div">
						<div class="Exhbomlistimg">
							<img v-lazy=" item.picture" alt="">
						</div>
						<div class="Exhbomtitle">
							{{item.title}}
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: '',
				xptjlists: ''
			}
		},
		methods: {
			nyxq() {
			  const loginInfo = JSON.parse(window.sessionStorage.getItem('token') || null)
			  if (loginInfo == null) {
			    this.$router.push({
			      path: '/login'
			    })
			  } else {
			    this.$router.push({
			      path: '/user'
			    })
			
			  }
			},
		},
		async mounted() {
			let res = await http.post('api/Common/index', {
				model: 'meet',
				type: 'content',
				mid: '4'
			})
			this.xptjlist =  res.data.data.list.data.slice(0, 4)
			
			let res1 = await http.post('api/Common/index',{
				model: 'meet',
				type: 'content',
				mid: '5'
			})
			this.xptjlists =  res1.data.data.list.data.slice(0, 4)
			
		}
	}
</script>

<style>
	#Exhibitionmetting {
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}
	
	/* 头部 */
	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
	}
	
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}
	
	.img_logo>img {
		width: 100%;
		height: 100%;
	}
	
	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}
	
	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}
	
	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}
	
	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}
	
	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}
	
	.sm_pub>ul::after {
		content: '';
		display: block;
		clear: both;
	}
	
	.sm_pub {
		float: left;
		margin-left: 40px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}
	
	.ct_title {
		float: left;
	
	}
	
	.ct_img {
		float: left;
		margin-left: 10px;
	}
	
	.ct_img>img {
		width: 12px;
		height: 10px;
	}
	
	.ckgd {
		float: right;
		margin-right: 20px;
		color: #999999;
		font-size: 15px;
		height: 36px;
		line-height: 46px;
		cursor: pointer;
	}
	
	/* 结尾 */
	
	
	.Exhbigk{
		width: 100%;
		height: 413px;
		margin-top: 20px;
		padding-top: 10px;
	}
	
	.Exhbitop{
		width: 100%;
		height: 190px;
	}
	
	.Exhbiboom{
		width: 100%;
		height: 190px;
		margin-top: 20px;
	}
	
	.Exhtopleft{
		width: 230px;
		height: 190px;
		background: #000;
		float: left;
		margin-left: 5px;
	}
	
	.Exhtopright{
		width: 950px;
		height: 190px;
		float: left;
		margin-left: 10px;
	}
	
	.Exhbomlist{
		width: 225px;
		height: 190px;
		float: left;
		margin-left: 10px;
		border: 1px solid #999999;
	}
	
	.Exhbomlistimg{
		width: 225px;
		height: 150px;
	}
	.Exhbomlistimg>img{
		width: 100%;
		height: 100%;
	}
	
	.Exhbomtitle{
		font-size: 16px;
		color: #000;
		font-weight: 600;
		line-height: 30px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
		padding: 5px;
		/* background-color: rgba(255,255,255,.16); */
	}
	
	.Exhtopleftimg{
		width: 80px;
		height: 80px;
		margin: 15px auto;
	}
	
	.Exhtitle{
		    color: #fff;
		    font-size: 20px;
		    letter-spacing: 10px;
		    font-weight: 600;
		    text-align: center;
	}
	
	.Exhbutton{
		color: #fff;
		    width: 110px;
		    border: 1px solid;
		    font-size: 16px;
			margin: 10px auto;
		    text-align: center;
		    letter-spacing: 2px;
		    padding: 4px 0;
		    cursor: pointer;
	}
</style>